<template>
  <authorization permissionKey="surgery_ward_preoperative_queue" can="read">
    <attendances queueType="surgery_preoperative" medicalRecordPath="cirurgia" />
  </authorization>
</template>

<script>
import attendances from "@/components/queues/attendances.vue";

  export default {
    name: "SurgicalWardPreoperative",
    components: {
      attendances,
    },
  };
</script>

<style lang="scss" scoped></style>
